import { render, staticRenderFns } from "./StepInformation.vue?vue&type=template&id=7c5187c0&"
import script from "./StepInformation.vue?vue&type=script&lang=js&"
export * from "./StepInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c5187c0')) {
      api.createRecord('7c5187c0', component.options)
    } else {
      api.reload('7c5187c0', component.options)
    }
    module.hot.accept("./StepInformation.vue?vue&type=template&id=7c5187c0&", function () {
      api.rerender('7c5187c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/sharedSteps/StepInformation.vue"
export default component.exports